import { Fragment, useMemo } from "react"
import PropTypes from "prop-types"
import { map, find, get } from "lodash"
import { Tabs, Tab as MuiTab, IconButton } from "@mui/material"
import { Close } from "@mui/icons-material"
import Tab from "components/material/tab"
import Tooltip from "components/material/tooltip"
import SelectFactorView from "components/select-factor-view"
import classNames from "classnames"
import "./style.scss"

export default function GraphTopBar({ value, tabs, onTabChanged, actions, displayAddView, openDialog, addView, factors }) {
  const customTabSelected = useMemo(() => {
    const tab = find(tabs, tab => tab.key === value)
    if (!tab) {
      return false
    }

    return tab.removable
  }, [value, tabs])

  const formattedTabs = useMemo(() => {
    return map(tabs, tab => {
      let label = tab.label
      if (tab.removable) {
        label = <div className="removable-tab">
          <div className="label">{label}</div>
          <Tooltip enterDelay={300} title="Remove View">
            <IconButton
              size="small"
              onClick={(ev) => {
                ev.stopPropagation()
                tab.onRemoveTab(tab.key)
              }}
              className="remove-button"
            >
              <Close />
            </IconButton>
          </Tooltip>
        </div>
      }

      const key = tab.key
      const tabProps = {
        value: get(tab, "value"),
        classes: { root: classNames({ removable: tab.removable }) },
        label,
        component: "div",
      }

      if (tab.tooltip) {
        return <Tab
          key={key}
          {...tabProps}
          tooltip={tab.tooltip}
        />
      }

      return <MuiTab key={key} {...tabProps} />
    })
  }, [tabs])

  return (
    <div className="components_graph-top-bar">
      <Tabs
        key="graph-top-bar"
        value={value}
        onChange={onTabChanged}
        className="trade-type"
        indicatorColor="primary"
        textColor="primary"
        scrollButtons="auto"
        variant="scrollable"
        classes={{ indicator: classNames({ "removable-tab-selected": customTabSelected }) }}
      >
        {formattedTabs}
      </Tabs>
      <div className={classNames("actions-container", { "add-view": displayAddView })}>
        {displayAddView && <SelectFactorView openDialog={openDialog} addView={addView} factors={factors} />}
        <div className="right-actions">{map(actions, (action, i) => <Fragment key={`action${i}`}>{action}</Fragment>)}</div>
      </div>
    </div>
  )
}

const TAB_SHAPE = PropTypes.shape({
  key: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  removable: PropTypes.bool,
  onRemoveTab: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  tooltip: PropTypes.element,
})

GraphTopBar.propTypes = {
  value: PropTypes.string.isRequired,
  tabs: PropTypes.arrayOf(TAB_SHAPE).isRequired,
  onTabChanged: PropTypes.func.isRequired,
  actions: PropTypes.arrayOf(PropTypes.node),
  displayAddView: PropTypes.bool,
  openDialog: PropTypes.func,
  addView: PropTypes.func,
  factors: PropTypes.array,
}
